import { isObject } from "./is.js";
//#region src/utils/json.ts
function getCircularDependencyReplacer() {
	const valueSeen = /* @__PURE__ */ new WeakSet();
	return function(_key, value) {
		if (isObject(value) && value !== null) {
			if (valueSeen.has(value)) return null;
			valueSeen.add(value);
		}
		return value;
	};
}
function stringifyExternalJson(json = {}) {
	return JSON.stringify(json !== null && json !== void 0 ? json : {}, getCircularDependencyReplacer());
}
function stringifyObjectValues(obj = {}) {
	const o = {};
	for (const [key, value] of Object.entries(obj)) o[key] = isObject(value) && value !== null ? stringifyExternalJson(value) : String(value);
	return o;
}
//#endregion
export { getCircularDependencyReplacer, stringifyExternalJson, stringifyObjectValues };

//# sourceMappingURL=json.js.map